const formatterCache = new Map();

export function formatPrice(amount, currency = 'INR') {
  if (amount === null || amount === undefined) return null;
  const normalizedCurrency = (currency || 'INR').toUpperCase();
  let formatter = formatterCache.get(normalizedCurrency);
  if (!formatter) {
    const locale = normalizedCurrency === 'INR' ? 'en-IN' : undefined;
    formatter = new Intl.NumberFormat(locale, { style: 'currency', currency: normalizedCurrency });
    formatterCache.set(normalizedCurrency, formatter);
  }
  return formatter.format(Number(amount));
}
